// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import QuoteComments from 'components/quote/QuoteComments/QuoteComments';
import QuoteCommentInput from 'components/quote/QuoteCommentInput/QuoteCommentInput';
import { QuotesActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/quotes';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  quoteId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class QuoteCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    QuotesActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    QuotesActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { quoteId, removeComment } = this.props;
    if (!quoteId || !removeComment.commentId) return;
    QuotesActions.removeComment({
      quoteId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { quoteId } = this.props;
    if (!quoteId) return Promise.resolve();
    return QuotesActions.editComment({
      quoteId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { quoteId } = this.props;
    if (!quoteId) return Promise.resolve();
    let comment = null;
    try {
      comment = await QuotesActions.writeComment({
        quoteId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await QuotesActions.readComments({ quoteId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { quoteId, shouldCancel } = this.props;
    if (!quoteId) return;
    try {
      if (shouldCancel) return;
      await QuotesActions.readComments({ quoteId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.quoteId !== this.props.quoteId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { quoteId } = this.props;
    if (!quoteId) return Promise.resolve(null);
    return QuotesActions.readSubComments({
      quoteId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <QuoteComments
          logged={logged}
          commentInput={logged && <QuoteCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="견적요청 댓글 삭제"
          description="이 견적요청 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    quoteId: state.quotes.quote && state.quotes.quote.id,
    comments: state.quotes.comments,
    subCommentsMap: state.quotes.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.quotes.quote || state.pender.pending['quotes/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.quotes.removeComment,
    commentsCount: state.quotes.quote && state.quotes.quote.comments_count,
  }),
  () => ({}),
)(withRouter(QuoteCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/quote/QuoteCommentsContainer.js